import { type Organisation } from '../models/organisation';
import { fetchData } from './fetchData';

export async function fetchOrganisations() {
  return await fetchData<{ data: Organisation[] }>(
    `/api/v2/documentation/organisations`,
    'GET'
  );
}
